import React from 'react';
import { NavLink } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import './navigation.scss';

export const Navigation: React.FC = observer(() => {
  const tools = [
    { path: '/', label: 'Home', icon: '🏠' },
    { path: '/timer', label: 'Timer', icon: '⏱️' },
    { path: '/ruler', label: 'Ruler', icon: '📏' },
    { path: '/calculator', label: 'Calculator', icon: '🧮' },
    { path: '/notepad', label: 'Notepad', icon: '📝' },
    { path: '/unit-converter', label: 'Unit Converter', icon: '🔄' },
    { path: '/currency-converter', label: 'Currency', icon: '💱' },
  ];

  return (
    <nav className="navigation">
      <div className="navigation__container">
        {tools.map(tool => (
          <NavLink
            key={tool.path}
            to={tool.path}
            className={({ isActive }) =>
              `navigation__link ${isActive ? 'navigation__link--active' : ''}`
            }
          >
            <span className="navigation__icon">{tool.icon}</span>
            <span className="navigation__label">{tool.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
});
